module.exports = ".askConten {\n  width: 100%;\n  height: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\nimg {\n  height: 45px;\n  width: 45px; }\n\n.askConten .card {\n  width: 62% !important;\n  height: 600px !important;\n  overflow-y: scroll;\n  scroll-behavior: smooth; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/questions-check/questions-check.component.scss
// module id = ./src/app/master/questions-check/questions-check.component.scss
// module chunks = main